export * from "./BasicTable";
export * from "./Threat_Report/InactiveAccountsTable";
export * from "./Threat_Report/MfaRegistrationTable";
export * from "./Threat_Report/MfaStatusTable";
export * from "./Threat_Report/RiskDetectionTable";
export * from "./Summary_Report/PreventedIncidentsTable";
